import { render, staticRenderFns } from "./ContentDivisor.vue?vue&type=template&id=757600fa&scoped=true"
var script = {}
import style0 from "./ContentDivisor.vue?vue&type=style&index=0&id=757600fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757600fa",
  null
  
)

export default component.exports